var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('doe-label',{attrs:{"name":_vm.name,"size":"small"}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._l((_vm.options),function(option,index){return _c('span',{key:index,class:option.value},[_vm._v("\n    "+_vm._s(option.text)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }